import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Card from "react-bootstrap/Card";
import { PageHeader } from "../../Header/PageHeader";
import "../Departments.css";
import 'animate.css'

// Lab Images

// import lab3 from "../../../assets/lab/cselab3-3.jpg";
// import lab2 from "../../../assets/lab/cselab2-2.jpg";
// import lab4 from "../../../assets/lab/cselab1-2.jpg";
// import lab1 from "../../../assets/lab/cselab1-1.jpg";
// import lab5 from "../../../assets/lab/cselab1-3.jpg";
// import lab6 from "../../../assets/lab/cselab2-1.jpg";
// import lab7 from "../../../assets/lab/cselab2-3.jpg";
// import lab8 from "../../../assets/lab/cselab3-1.jpg";
// import lab9 from "../../../assets/lab/cselab3-2.jpg";
// import lab10 from "../../../assets/lab/cselab4-1.jpg";
// import lab11 from "../../../assets/lab/cselab4-2.jpg";
// import lab12 from "../../../assets/lab/cselab4-3.jpg";

// Circuits Lab 

// import circ1 from "../../../assets/lab/EEE/CircuitsLab/eeelab2-1.jpg";
// import circ2 from "../../../assets/lab/EEE/CircuitsLab/eeelab2-2.jpg";
// import circ3 from "../../../assets/lab/EEE/CircuitsLab/eeelab2-3.jpg";

// Machines Lab 

// import mach1 from "../../../assets/lab/EEE/MachinesLab/eeelab1-1.jpg";
// import mach2 from "../../../assets/lab/EEE/MachinesLab/eeelab1-2.jpg";
// import mach3 from "../../../assets/lab/EEE/MachinesLab/eeelab1-3.jpg";

// PeEm Lab

// import peem1 from "../../../assets/lab/EEE/PeEmLab/eeelab3-1.jpg";
// import peem2 from "../../../assets/lab/EEE/PeEmLab/eeelab3-2.jpg";
// import peem3 from "../../../assets/lab/EEE/PeEmLab/eeelab3-3.jpg";

// PowerSystems Lab

// import pow1 from "../../../assets/lab/EEE/PowerSystemsLab/eeePlab2-1.jpg";
// import pow2 from "../../../assets/lab/EEE/PowerSystemsLab/eeePlab2-2.jpg";
// import pow3 from "../../../assets/lab/EEE/PowerSystemsLab/eeePlab2-3.jpg";

// Simulation Lab 

// import sim1 from "../../../assets/lab/EEE/SimulationLab/eeelab4-1.jpg";
// import sim2 from "../../../assets/lab/EEE/SimulationLab/eeelab4-2.jpg";
// import sim3 from "../../../assets/lab/EEE/SimulationLab/eeelab4-3.jpg";
import axios from "axios";
import { resources } from "../../Resourses/Resources";
import ViewLabImages from "../ViewLabPhotos/ViewLabPhotos";



const Labs = () => {
  const [key, setKey] = useState("All");
  const [viewAllImages, setAllImages] = useState([])
  const [electricSimulationData, setElectricSimulation] = useState([])
  const [electricMachineData, setElectricMachineData] = useState([])
  const [powerSystemData, setPowerSysytemdata] = useState([])
  const [simulationData,setSimulationData]=useState([])
  const [peAndEmLab,setPeAndEmLAb]=useState([])
  const date = new Date();
  const currentYear = date.getFullYear()
  const currentPath = window.location.pathname;
  const path = currentPath.split("/").pop();
  const labType=path.toUpperCase()
  console.log("path===>",path.toUpperCase())
  useEffect(() => {

    const fetchAllImages = async () => {
      try {
        const details = await axios.get(resources.APPLICATION_URL + `get/lab/imagesByYear?academicYear=${currentYear}&department=EEE`)
        // setAllImages(details.data)
        const allPhotos = details.data

        const simulationImages = allPhotos.filter((items) => items.labName === "Simulation Lab")
        const electricMachines = allPhotos.filter((items) => items.labName === "ElectricMachines Lab")
        const electricSimulation = allPhotos.filter((items) => items.labName === "ElectricSimulation Lab")
        const powerSystemLab = allPhotos.filter((items) => items.labName === "PowerSystemLab Lab")
        const peAndEaLab = allPhotos.filter((items) => items.labName === "PE AND EA LAB")

        const allImages=allPhotos[0].filePath.split(",")
        // console.log("all images===>",allImages)
     
        const splitteddata = simulationImages[0].filePath.split(",")
        const elecmach = electricMachines[0].filePath.split(",")
        const eleSimu = electricSimulation[0].filePath.split(",")
        const poweSystem = powerSystemLab[0].filePath.split(",")
        const peAnd = peAndEaLab[0].filePath.split(",")
        setElectricMachineData(elecmach)
        setElectricSimulation(eleSimu)
        console.log("all simulationImages===>",elecmach)

        setAllImages(allImages)
        setPowerSysytemdata(poweSystem)
        setSimulationData(splitteddata)
        setPeAndEmLAb(peAnd)
      } catch (error) {
        console.log("error in fetch images===>", error)
      }
    }
    fetchAllImages()
  }, [currentYear])
  return (
    <div className="container">
      <PageHeader name="Laboratories" />
      {/* <Card style={{ width: "100%", margin: "20px 0px" }}>
        <Card.Header>CSE Laboratories</Card.Header>
        <Card.Body>
          <Card.Title>We have Fully Equipped Laboratories</Card.Title>
          <Card.Text>
            we have the several Computer Labs equipped with latest software's
            and workstations. It is connected to internet through a lease line
            to facilitate high speed internet access. All the computers are
            connected through a structured network. Printer and copier
            facilities are also available in the lab. Our dedicated faculty and
            staff are proud of their impressive credentials, which are
            comparable to those of the best career instructors.
          </Card.Text>
        </Card.Body>
      </Card> */}

      <div className="content">
      <ViewLabImages labType={labType}/>

        {/* <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="All" title="All">
            <div className="col-lg-12 align center col-md-12 animate__animated animate__zoomIn">


              <div className="row g-12 pt-12">
                {viewAllImages.map((items, index) => {
                  return (

                    <div className="col-4 ">
                      <img
                        className="img-fluid bg-light p-10"
                        src={`data:application/pdf;base64,${items}`}
                        style={{ width: "100px", height: "100px" }}
                      />
                      <p style={{ textAlign: "center" }}>Electrical Machines Lab</p>
                    </div>
                  )

                })}

              </div>

            </div>

            <br />

            <div className="col-lg-12 align center col-md-12 animate__animated animate__zoomIn">
              <div className="row g-12 pt-12">
                <div className="col-4 ">
                  <img
                    className="img-fluid bg-light p-10"
                    src={mach1}
                    alt="lab-img"
                  />
                  <p style={{ textAlign: "center" }}>Electrical Circuits Lab</p>
                </div>
                <div className="col-4 ">
                  <img
                    className="img-fluid bg-light p-10"
                    src={mach2}
                    alt="lab-img"
                  />
                  <p style={{ textAlign: "center" }}>Electrical Circuits Lab</p>
                </div>
                <div className="col-4 ">
                  <img
                    className="img-fluid bg-light p-10"
                    src={mach3}
                    alt="lab-img"
                  />
                  <p style={{ textAlign: "center" }}>Electrical Circuits Lab</p>
                  <br />
                </div>
              </div>
            </div>
            <br />

            <div className="col-lg-12 align center col-md-12 animate__animated animate__zoomIn">
              <div className="row g-12 pt-12">
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-10"
                    src={peem1}
                    alt="lab-img"
                  />
                  <p style={{ textAlign: "center" }}>Power Systems Lab</p>
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-10"
                    src={peem2}
                    alt="lab-img"
                  />
                  <p style={{ textAlign: "center" }}>Power Systems Lab</p>
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-10"
                    src={peem3}
                    alt="lab-img"
                  />
                  <p style={{ textAlign: "center" }}>Power Systems Lab</p>
                </div>
              </div>
            </div>
            <br />

            <div className="col-lg-12 align center col-md-12 animate__animated animate__zoomIn">
              <div className="row g-12 pt-12">
                <div className="col-4 ">
                  <img
                    className="img-fluid bg-light p-10"
                    src={pow1}
                    alt="lab-img"
                  />
                  <p style={{ textAlign: "center" }}>PE and EM Lab</p>
                </div>
                <div className="col-4 ">
                  <img
                    className="img-fluid bg-light p-10"
                    src={pow2}
                    alt="lab-img"
                  />
                  <p style={{ textAlign: "center" }}>PE and EM Lab</p>
                </div>
                <div className="col-4 ">
                  <img
                    className="img-fluid bg-light p-10"
                    src={pow3}
                    alt="lab-img"
                  />
                  <p style={{ textAlign: "center" }}>PE and EM Lab</p>
                  <br />
                </div>
              </div>
            </div>

            <br />
            <div className="col-lg-12 align center col-md-12 animate__animated animate__zoomIn">
              <div className="row g-12 pt-12">
                <div className="col-4 ">
                  <img
                    className="img-fluid bg-light p-10"
                    src={sim1}
                    alt="lab-img"
                  />
                  <p style={{ textAlign: "center" }}>Simulation Lab</p>
                </div>
                <div className="col-4 ">
                  <img
                    className="img-fluid bg-light p-10"
                    src={sim2}
                    alt="lab-img"
                  />
                  <p style={{ textAlign: "center" }}>Simulation Lab</p>
                </div>
                <div className="col-4 ">
                  <img
                    className="img-fluid bg-light p-10"
                    src={sim3}
                    alt="lab-img"
                  />
                  <p style={{ textAlign: "center" }}>Simulation Lab</p>
                  <br />
                </div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="SIMULATION LAB " title="SIMULATION LAB ">
            <div className="col-lg-12 align center col-md-12 animate__animated animate__zoomIn">
              <div className="row g-12 pt-12">
                {simulationData && simulationData.length > 0 && simulationData.map((items, index) => {
                  return (

                    <div className="col-4 ">
                     <img
                        className="img-fluid bg-light p-10"
                        src={`data:application/pdf;base64,${items}`}
                        style={{ width: "100px", height: "100px" }}
                      />
                      <p style={{ textAlign: "center" }}>Simulation Lab</p>
                    </div>
                  )

                })}
 
              </div>
            </div>
          </Tab>
          <Tab eventKey="ELECTRICAL MACHINES LAB" title="ELECTRICAL MACHINES LAB">
            <div className="col-lg-12 align center col-md-12 animate__animated animate__zoomIn">
              <div className="row g-12 pt-12">
              {electricMachineData && electricMachineData.length > 0 && electricMachineData.map((items, index) => {
                  return (

                    <div className="col-4 ">
                      <img
                        className="img-fluid bg-light p-10"
                        src={`data:application/pdf;base64,${items}`}
                        style={{ width: "100px", height: "100px" }}
                      />
                      <p style={{ textAlign: "center" }}>Simulation Lab</p>
                    </div>
                  )

                })}
         
              </div>
            </div>
          </Tab>
          <Tab eventKey="ELECTRICAL CIRCUITS LAB" title="ELECTRICAL CIRCUITS LAB">
            <div className="col-lg-12 align center col-md-12 animate__animated animate__zoomIn">
              <div className="row g-12 pt-12">
              {electricSimulationData && electricSimulationData.length > 0 && electricSimulationData.map((items, index) => {
                  return (

                    <div className="col-4 ">
                      <img
                        className="img-fluid bg-light p-10"
                        src={`data:application/pdf;base64,${items}`}
                        style={{ width: "100px", height: "100px" }}
                      />
                      <p style={{ textAlign: "center" }}>Electrical Circuits Lab</p>
                    </div>
                  )

                })}
        
              </div>
            </div>
          </Tab>
          <Tab eventKey="PE AND EM LAB " title="PE AND EM LAB ">
            <div className="col-lg-12 align center col-md-12 animate__animated animate__zoomIn">
              <div className="row g-12 pt-12">
              {peAndEmLab && peAndEmLab.length > 0 && peAndEmLab.map((items, index) => {
                  return (

                    <div className="col-4 ">
                      <img
                        className="img-fluid bg-light p-10"
                        src={`data:application/pdf;base64,${items}`}
                        style={{ width: "100px", height: "100px" }}
                      />
                      <p style={{ textAlign: "center" }}>Electrical Circuits Lab</p>
                    </div>
                  )

                })}
        
           
              </div>
            </div>
          </Tab>
          <Tab eventKey="COMPUTER LAB3" title="POWER SYSTEMS LAB">
            <div className="col-lg-12 align center col-md-12 animate__animated animate__zoomIn">
              <div className="row g-12 pt-12">
              {powerSystemData && powerSystemData.length > 0 && powerSystemData.map((items, index) => {
                  return (

                    <div className="col-4 ">
                      <img
                        className="img-fluid bg-light p-10"
                        src={`data:application/pdf;base64,${items}`}
                        style={{ width: "100px", height: "100px" }}
                      />
                      <p style={{ textAlign: "center" }}>POWER SYSTEMS LAB</p>
                    </div>
                  )

                })}
         
            
              </div>
            </div>
          </Tab>
        </Tabs> */}
      </div>
    </div>
  );
};

export default Labs;
